<template>
  <div class="datacomponents">
    <!-- 柱形图3/4 -->
    <!-- <img src="../assets/img/backs.png" alt="" class="centerBacks" /> -->

    <div class="charts2 charts2Pic">
      <div class="chartsBtn">
        <div
          class="chartsbtn-item"
          v-for="(item, index) in columData"
          :key="index"
          @click="amountClick(item, index)"
          :class="{ 'btn-act': activeIndex === index }"
        >
          {{ item.title }}
        </div>
        <div class="downloadPic" @click="downloadPic">
          <img src="../assets/img/dawn.png" alt="" />
        </div>
        <!-- <div class="chartsbtn-item" @click="numberClick">签约数量</div> -->
        <!-- <div class="chartsbtn-item" @click="mianduimian">面对面</div> -->
      </div>
      <div id="myCharts8"></div>
    </div>
    <div class="charts3 charts3Pic">
      <div style="width: 100%; height: 100%; position: relative">
        <!-- 柱形图3 -->
        <div class="chartsBtn">
          <div
            class="chartsbtn-item"
            v-for="(item, index) in powerData"
            :key="index"
            @click="powerClick(item, index)"
            :class="{ 'btn-act': powerIndex === index }"
          >
            {{ item.title }}
          </div>
          <div class="downloadPic" @click="downloadPic">
            <img src="../assets/img/dawn.png" alt="" />
          </div>
          <!-- <div class="chartsbtn-item" @click="numberClick">签约数量</div> -->
          <!-- <div class="chartsbtn-item" @click="mianduimian">面对面</div> -->
        </div>
        <div class="chartsPic">
          <div class="circular">
            <div class="zhuanhualv">整体转化率15.6%</div>
            <div class="cir-item">
              <div class="cir-item-text">跟进(1348)</div>
              <img src="../assets/img/juxing.png" alt="" class="circular1" />
            </div>
            <div class="cir-item">
              <div class="cir-item-text cir-item2">带看(1348)</div>
              <img src="../assets/img/juxing2.png" alt="" class="circular2" />
            </div>
            <div class="cir-item">
              <div class="cir-item-text cir-item3">签约认购(1348)</div>
              <img src="../assets/img/juxing3.png" alt="" class="circular3" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
import html2canvas from "html2canvas";

export default {
  data() {
    return {
      powerData: [
        {
          id: 1,
          title: "全部",
        },
        {
          id: 2,
          title: "电话",
        },
        {
          id: 3,
          title: "微信",
        },
        {
          id: 4,
          title: "面对面",
        },
      ],
      powerIndex: 0,
      //项目营销数据模拟
      yxdata: [
        "信华国际商务中心",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期七",
        "星期八",
        "星期九",
        "星期十",
      ],
      activeIndex: 0,
      powerIndex: 0,
      // 柱形图2按钮
      powerData: [
        {
          id: 1,
          title: "全部",
        },
        {
          id: 2,
          title: "电话",
        },
        {
          id: 3,
          title: "微信",
        },
        {
          id: 4,
          title: "面对面",
        },
      ],
      // 柱形图1按钮
      columData: [
        {
          id: 1,
          title: "签约金额",
        },
        {
          id: 2,
          title: "签约数量",
        },
      ],
    };
  },
  mounted() {
    this.drawPowerCharts();
  },
  methods: {
    // 下载图表
    downloadPic() {
      html2canvas(document.getElementById("myCharts8")).then(function (canvas) {
        var img = canvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
        // 创建a标签，实现下载
        var creatIMg = document.createElement("a");
        creatIMg.download = "图表.png"; // 设置下载的文件名，
        creatIMg.href = img; // 下载url
        document.body.appendChild(creatIMg);
        creatIMg.click();
        creatIMg.remove(); // 下载之后把创建的元素删除
      });
    },
    // 销售强度
    powerClick(item, index) {
      this.powerIndex = index;
    },
    // 签约金额
    amountClick(item, index) {
      this.activeIndex = index;
    },
    // 销售强度
    powerClick(item, index) {
      this.powerIndex = index;
    },
    // 项目营销强度
    drawPowerCharts() {
      let myChart8 = this.$echarts.init(document.getElementById("myCharts8"));
      // 绘制图表
      myChart8.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          itemWidth: 10, // 设置图例标记宽度
          itemHeight: 10, // 设置图例标记高度
          itemGap: 20, // 设置图例项之间的间距
          x: "left",
          top: "20px",
          left: "80px",
          data: ["合肥", "北京", "沈阳", "南昌", "九江", "上海"],
          textStyle: {
            color: ["#8DDAFF"],
          },
        },
        calculable: true,
        series: [
          {
            name: "总和\n\n35",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["50%", "40%"],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "center",
                  color: "#16BDFF",
                  formatter: "{a}", // 在 label 中设置 formatter 显示数字35
                  fontSize: 24,
                },
                labelLine: {
                  show: false,
                },
              },
              emphasis: {},
            },

            data: [
              { value: 335, name: "合肥" },
              { value: 310, name: "北京" },
              { value: 234, name: "沈阳" },
              { value: 135, name: "南昌" },
              { value: 548, name: "九江" },
              { value: 148, name: "上海" },
            ],
          },
        ],
      });
    },
  },
};
</script>
    
    <style scoped>
.datacomponents {
  display: flex;
  width: 100%;
}
.downloadPic {
  width: 35px;
  height: 35px;
  right: 4vh;
  position: absolute;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #01115d;
  border-radius: 11px;
}
.downloadPic img {
  width: 26px;
  height: 26px;
}
.zhuanhualv {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #8ddaff;
  margin: 0 0 15px 0;
}
.charts3Pic {
  height: 337px !important;
}
.charts2Pic {
  height: 337px !important;
}
.cir-item-text {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 48%);
  font-size: 15px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
.cir-item2 {
  transform: translate(-50%, -36%);
}
.cir-item3 {
  transform: translate(-50%, -32%);
}
.chartsPic {
  display: flex;
  justify-content: center;
  align-items: center;
}
.circular1 {
  width: 312px;
  height: 72px;
}
.circular2 {
  width: 235px;
  height: 66px;
  margin-top: -20px;
}
.circular3 {
  width: 158px;
  height: 51px;
  margin-top: -12px;
}
.circular {
  margin-top: 3vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  transform: translate(0px, -50%);
}
.chartsBtn {
  display: flex;
  align-items: center;
  margin: 30px 0 0 20px;
  /* background: red; */
}
.chartsbtn-item {
  margin-right: 20px;
  border-radius: 20px;
  padding: 5px 12px;
  color: #7abfe9;
  background: #0a1162;
  cursor: pointer;
  -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
}
.btn-act {
  background: #1e67c5 !important;
}
#myCharts9 {
  width: 100%;
  height: 100%;
}
#myCharts8 {
  width: 100%;
  height: 100%;
}
.btn-act {
  background: rgba(0, 93, 255, 0.16) !important;
  box-shadow: inset 0px 1px 80px 0px rgba(49, 184, 255, 0.5) !important;
}
.chartsBtn {
  display: flex;
  align-items: center;
  margin: 30px 0 0 20px;
  position: relative;
  /* background: red; */
}
.chartsbtn-item {
  margin-right: 20px;
  border-radius: 20px;
  padding: 5px 12px;
  color: #31b8ff;
  background: #0a1162;
  cursor: pointer;
}
.charts2 {
  flex: 1;
  width: 100%;
  height: 70vh;
  background: rgba(0, 93, 255, 0.16);
  box-shadow: inset 0px 1px 80px 0px rgba(0, 152, 255, 0.5);
  border-radius: 16px;
  border: 1px solid #1d7fff;
  display: flex;
  flex-direction: column;
  margin: 20px 10px 0 0;
}
.charts3 {
  flex: 1;
  width: 100%;
  height: 70vh;
  background: rgba(0, 93, 255, 0.16);
  box-shadow: inset 0px 1px 80px 0px rgba(0, 152, 255, 0.5);
  border-radius: 16px;
  border: 1px solid #1d7fff;
  display: flex;
  flex-direction: column;
  margin: 20px 0 0 10px;
}
.columnChart {
  display: flex;
}
.centerBacks {
  width: 1200px;
  height: 46.8vh;
  margin-left: 2px;
  position: absolute;
  margin-top: 21px;
}
</style>


// WEBPACK FOOTER //
// src/components/pieShow.vue